import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { UserCog, CheckCircle2, Clock } from "lucide-react";

export default function OutsideRecruiters() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/interviews/outside-recruiters").then((r) => setItems(r.data.items)).catch((e) => { toast.error(apiError(e)); setItems([]); });
  useEffect(() => { load(); }, []);

  const toggle = async (u) => {
    try { await api.post(`/interviews/outside-recruiters/${u.user_id}`, { approved: !u.approved }); toast.success(u.approved ? "Access revoked" : "Outside Recruiter approved"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  if (!items) return <p className="text-slate-400 py-16 text-center">Loading…</p>;
  return (
    <div>
      <div className="mb-4"><h1 className="font-display text-xl font-bold text-slate-900">Outside Recruiters</h1>
        <p className="text-sm text-slate-400">Approve external referral partners before they can schedule controlled interviews. Approval is never automatic.</p></div>
      {items.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 bg-white py-16 text-center" data-testid="or-empty">
          <UserCog className="w-10 h-10 mx-auto text-slate-300 mb-3" />
          <p className="text-slate-600 font-medium">No Outside Recruiters yet</p>
          <p className="text-sm text-slate-400 mt-1">Invite a user with the Outside Recruiter role from Users, then approve them here.</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="outside-recruiters-list">
          {items.map((u) => (
            <div key={u.user_id} className="rounded-xl border border-slate-200 bg-white shadow-sm p-4 flex items-center justify-between gap-4" data-testid={`or-row-${u.user_id}`}>
              <div className="min-w-0">
                <p className="font-semibold text-slate-800 truncate">{u.name}</p>
                <p className="text-sm text-slate-400 truncate">{u.email}</p>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full ${u.approved ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-700"}`} data-testid={`or-status-${u.user_id}`}>
                  {u.approved ? <><CheckCircle2 className="w-3.5 h-3.5" />Approved</> : <><Clock className="w-3.5 h-3.5" />Pending</>}
                </span>
                <Switch checked={u.approved} onCheckedChange={() => toggle(u)} data-testid={`or-toggle-${u.user_id}`} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
